var site = site || {};
var generic = generic || {};
var POWERREVIEWS = POWERREVIEWS || {};
var pr_loyaltymember2 = '0',
  pr_smartrewards2 = '';

(function ($) {
  Drupal.behaviors.writeReview = {
    renderForm: function (args) {
      args = args || {};
      var context = args.context;
      var user = args.user;

      if (
        POWERREVIEWS &&
        typeof Drupal.settings.power_reviews !== 'undefined' &&
        typeof generic !== 'undefined' &&
        typeof generic.env !== 'undefined' &&
        typeof generic.env.query !== 'undefined' &&
        typeof context !== 'undefined'
      ) {
        var $writeReviewContainer = $('#power_review_container', context);
        var $productImageContainer = $('.js-product-image', $writeReviewContainer);
        var product_id = 'PROD' + this.sanitizePageID(generic.env.query('pr_page_id'));
        var params = [
          {
            products: [product_id],
            category_fields: ['products'],
            product_fields: ['PROD_RGN_NAME', 'SHORT_DESC', 'SUB_LINE', 'IMAGE_SPP', 'url']
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();

            if (typeof productDetails !== 'undefined') {
              var productName =
                typeof Drupal.settings.power_reviews.show_translation_title !== 'undefined'
                  ? productDetails.products[0].SUB_LINE
                  : productDetails.products[0].PROD_RGN_NAME;
              var productImageSrc =
                typeof productDetails.products[0].IMAGE_SPP === 'object'
                  ? productDetails.products[0].IMAGE_SPP[0]
                  : productDetails.products[0].IMAGE_SPP;
              var productImageUrl = productDetails.products[0].url;
              var productSubLine = productDetails.products[0].SHORT_DESC;

              $productImageContainer.attr('src', productImageSrc).attr('alt', productName);
              $('.js-product-image-link', $writeReviewContainer).attr('href', productImageUrl);
              $('.js-pr-product-name', $writeReviewContainer).html(productName);
              if (Drupal.settings.power_reviews.show_sub_line) {
                $('.js-pr-sub-line', $writeReviewContainer).html(productSubLine);
              }
            }
          }
        });

        var page_id = this.sanitizePageID(generic.env.query('pr_page_id'));
        var pr_locale =
          document.location.href.search('fr.clinique.ca') !== -1 &&
          typeof Drupal.settings.power_reviews.locale_fr !== 'undefined'
            ? Drupal.settings.power_reviews.locale_fr
            : Drupal.settings.power_reviews.locale;
        var pr_merchant_id =
          document.location.href.search('fr.clinique.ca') !== -1 &&
          typeof Drupal.settings.power_reviews.merchant_id_fr !== 'undefined'
            ? Drupal.settings.power_reviews.merchant_id_fr
            : Drupal.settings.power_reviews.merchant_id;
        var pr_args = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: pr_locale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: pr_merchant_id,
          page_id: page_id,
          components: {
            Write: 'pr-write'
          }
        };

        if (typeof user !== 'undefined' && typeof user.user_id !== 'undefined') {
          pr_args.merchant_user_id = user.user_id;
        }
        if (
          typeof user !== 'undefined' &&
          typeof user.is_loyalty_member !== 'undefined' &&
          user.is_loyalty_member
        ) {
          pr_loyaltymember2 = '1';
          pr_smartrewards2 = $('.js-elist-member', $('.write_a_review__container')).html();
        }

        pr_args.on_submit = function (config, data) {
          $(window).scrollTop(0);
          $('.js-war-heading', $writeReviewContainer).addClass('hidden');
          if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
            site.track.reviewWriteEnd();
          }
        };

        pr_args.on_render = function (config, data) {
          var is_loyalty_member = user.is_loyalty_member;
          var $loyalityButtonContainer = $('#pr-smartrewards .pr-btn-default');
          var $reviewContainer = $('.js-write-review-container', context);
          var $emailCollect = document.getElementById('pr-email_collection-input');
          var lastValue = $emailCollect.value;
          var inputEvent = new Event('input', { bubbles: true });
          // eslint-disable-next-line no-underscore-dangle
          var tracker = $emailCollect._valueTracker;

          if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined' && tracker) {
            $emailCollect.value = user.email_address;
            tracker.setValue(lastValue);
            $emailCollect.dispatchEvent(inputEvent);
          }

          $reviewContainer
            .find('.pr-rating-stars [role=radio]')
            .attr('data-test-id', 'overall_rating_star_select');
          $reviewContainer
            .find('.pr-bottomline-form-group [role=radio]')
            .attr('data-test-id', 'review_recommend_product_select');
          $reviewContainer
            .find('.pr-name-form-group .pr-textinput')
            .attr('data-test-id', 'reviewer_name');
          $reviewContainer
            .find('.pr-location-form-group .pr-textinput')
            .attr('data-test-id', 'reviewer_location');
          $reviewContainer
            .find('.pr-age-form-group .form-control')
            .attr('data-test-id', 'reviewer_age');
          $reviewContainer
            .find('.pr-headline-form-group .pr-textinput')
            .attr('data-test-id', 'review_title');
          $reviewContainer
            .find('.pr-comments-form-group .pr-textarea')
            .attr('data-test-id', 'review_text');
          $reviewContainer
            .find('.pr-cb-tag-container')
            .attr('data-test-id', 'product_benefit_select');
          $reviewContainer
            .find('.pr-skinconcerns-form-group .pr-btn-add-tag')
            .attr('data-test-id', 'add_your_benefit');
          $reviewContainer.find('.pr-submit .pr-btn-review').attr('data-test-id', 'review_submit');
          if (is_loyalty_member) {
            $loyalityButtonContainer.addClass('active').attr('aria-checked', true);
            $('.pr-btn-default:first', $('.pr-loyaltymember-form-group'))
              .addClass('active')
              .attr('aria-checked', true);
          } else {
            $('.pr-btn-default:last', $('.pr-loyaltymember-form-group'))
              .addClass('active')
              .attr('aria-checked', true);
          }
        };
        POWERREVIEWS.display.render(pr_args);
      }
    },
    triggerSignin: function (args) {
      var context = args.context;
      var signinRequest = args.signinRequest;
      var that = this;
      var paramObj = {};

      if (signinRequest) {
        var inputVals = $('#power_review_container', context)
          .find('#js-signin-form')
          .serializeArray();

        // loop through all the fields and get the values
        $.each(inputVals, function (index, formObj) {
          paramObj[formObj.name] = formObj.value;
        });
      } else {
        var email = $('.pr_email', context).val();

        paramObj.NEW_USER_EMAIL_ADDRESS = email;
        paramObj._SUBMIT = 'signin_new_user';
      }
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (r) {
          var userInfo = r.getData().userinfo;

          $('.js-signin-err-msg', context).empty().addClass('hidden');
          $('#pwr_signin', context).addClass('hidden');
          that.renderForm({
            context: context,
            user: userInfo
          });
        },
        onFailure: function (r) {
          var messages = r.getMessages();

          $('.js-signin-err-msg', context).empty().html(messages[0].text).removeClass('hidden');
        }
      });
    },
    isValidEmailAddress: function (emailAddress) {
      var atpos = emailAddress.indexOf('@');
      var dotpos = emailAddress.lastIndexOf('.');

      return atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailAddress.length ? false : true;
    },
    sanitizePageID: function (pr_page_id) {
      return pr_page_id.indexOf('PROD') >= 0 ? pr_page_id.substr(4) : pr_page_id;
    },
    renderProductInfo: function () {
      var $signinImageContainer = $('#pwr_signin .js-product-image');

      if ($signinImageContainer.length) {
        var product_id = 'PROD' + generic.env.query('pr_page_id');
        var params = [
          {
            products: [product_id],
            category_fields: ['products'],
            product_fields: ['PROD_RGN_NAME', 'IMAGE_SPP']
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();

            if (typeof productDetails.products[0] !== 'undefined') {
              var productImageSrc =
                typeof productDetails.products[0].IMAGE_SPP === 'object'
                  ? productDetails.products[0].IMAGE_SPP[0]
                  : productDetails.products[0].IMAGE_SPP;
              var productName = productDetails.products[0].PROD_RGN_NAME;

              $signinImageContainer
                .attr('src', productImageSrc)
                .attr('alt', productName)
                .attr('title', productName);
            }
          }
        });
      }
    },
    attach: function (context) {
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;
      var that = this;
      var appName = generic.env.query('appName');

      if (appName) {
        document.title =
          site.translations.product.product_pr_ask_answer + ' | ' + Drupal.settings.site_name;
      }
      if (signedIn) {
        $(document).on('user.loaded', function (e, user) {
          that.renderForm({
            context: context,
            user: user
          });
        });
      } else {
        if (Drupal.settings.power_reviews.signin_required) {
          var page_id = that.sanitizePageID(generic.env.query('pr_page_id'));

          // login flow method
          if (Drupal.settings.power_reviews.partial_signin) {
            $('#pwr_signin', context).removeClass('hidden');
            var pr_valid_email = $('#pr_valid_email', context).html();

            that.renderProductInfo();
            // check whether registered user
            $('.email_check .btn-pr').on('click', function (evt) {
              evt.preventDefault();
              var email = $('.pr_email').val();

              if (that.isValidEmailAddress(email)) {
                generic.jsonrpc.fetch({
                  method: 'user.registered',
                  params: [{ email_address: email }],
                  onSuccess: function (r) {
                    $('.js-signin-err-msg', context).empty().addClass('hidden');
                    var val = r.getValue();
                    var isUser = val !== null && val === 1;

                    if (isUser) {
                      // show full login
                      $('#pwr_signin .email_check').addClass('hidden');
                      $('#pwr_signin .full_sign_in').removeClass('hidden');
                      $('#pwr_signin input[name="EMAIL_ADDRESS"]').val(email);
                    } else {
                      // anonymous write-a-review
                      that.triggerSignin({
                        context: context,
                        signinRequest: 0
                      });
                    }
                  },
                  onFailure: function (r) {}
                });
              } else {
                $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
              }
            });
            $('.full_sign_in .btn-pr').on('click', function (evt) {
              evt.preventDefault();
              var email = $('#js-signin-form input[name="EMAIL_ADDRESS"]').val();

              if (that.isValidEmailAddress(email)) {
                $('.js-signin-err-msg', context).empty().addClass('hidden');
                that.triggerSignin({
                  context: context,
                  signinRequest: 1
                });
              } else {
                $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
              }
            });
            $(document).on('prodcat.status', that.renderProductInfo);
          } else {
            var params = new URL(document.location).searchParams;
            var returnUrl = encodeURIComponent(
              document.location.pathname + '?' + params.toString()
            );

            if (appName) {
              returnUrl = encodeURIComponent(
                document.location.pathname + '?' + params.toString() + '&appName=' + appName
              );
            }
            var signinUrl = '/account/signin.tmpl' + '?RETURN_URL=' + returnUrl;

            document.location.href = signinUrl;
          }
        } else {
          that.renderForm({ context: context });
        }
      }
    }
  };
})(jQuery);
